import React from 'react';
import {Box, Tooltip, Typography} from '@mui/material';
import {SUPPRESSED_COPY} from '../../utils/suppression';

const NAVY = '#052F44';

/**
 * The one way a dashboard shows a score that is under the n floor.
 *
 *   inline (default) — bar rows, KPI tiles, "to watch" lists: optional bold label,
 *                      then the copy in muted italics (the markup the Cyber Risks
 *                      By Age / By Gender tabs have used since the first release).
 *   cell             — dense tables and heatmaps: a short "n < 10" with the full
 *                      copy in the tooltip and in aria-label.
 */
export const SuppressedValue = ({variant = 'inline', label}) => (
    variant === 'cell' ? (
        <Tooltip title={SUPPRESSED_COPY} arrow placement="top">
            <Typography component="span" aria-label={SUPPRESSED_COPY} sx={{fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic', whiteSpace: 'nowrap', cursor: 'default'}}>
                n&nbsp;&lt;&nbsp;10
            </Typography>
        </Tooltip>
    ) : (
        <Box>
            {label && <Typography sx={{fontSize: '13.5px', fontWeight: 700, color: NAVY, mb: 0.5}}>{label}</Typography>}
            <Typography sx={{fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic'}}>{SUPPRESSED_COPY}</Typography>
        </Box>
    )
);

/**
 * A cell of a rowsFrom() row: the placeholder when that column's cell is
 * suppressed (row._suppressed[k]), else the formatted text the row carries.
 */
export const RowCell = ({row, k, variant = 'cell'}) => (
    row?._suppressed?.[k] ? <SuppressedValue variant={variant}/> : <>{row?.[k]}</>
);

export default SuppressedValue;
